// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3414":"css/admin-app.6858","9534":"css/app.6858"}[chunkId] + ".css";
};